
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  recurrenceTypesOptions, weekDaysOptions, showRecurrenceDaysOptions, recurrenceOccurMessage,
  recurrenceWeekToDays, isNumber, setRecurrenceDayOnInput, recurrenceEndDate
} from '@/helpers/data';
import dayjs from 'dayjs';

@Component
export default class RecurrenceFields extends Vue {
  @Prop({ required: true }) value!: any;
  @Prop({ default: false }) editSeries!: any;
  @Prop({ default: false}) disableDiffJobs!: boolean;

  endDateMenu = false;
  userChangedDaysOfWeek = false;
  showDayError = false;

  mounted() {
    setRecurrenceDayOnInput(this.value, this.userChangedDaysOfWeek);
    if (this.editSeries) {
      this.onDaysChange();
    }
    if (!this.value.end_date) {
      this.value.end_date = recurrenceEndDate();
    }
  }

  get typeOptions() {
    return recurrenceTypesOptions(this.value.interval).options;
  }

  get weekDayOptions() {
    return weekDaysOptions();
  }

  get showDays() {
    return showRecurrenceDaysOptions(this.value);
  }

  get occurMessage() {
    if (!this.value.recurrence_type) return '';
    return recurrenceOccurMessage(this.value);
  }

  get disableDiffJob() {
    if (this.editSeries || this.disableDiffJobs) {
      this.value.recurrence_diff_jobs = this.value.job_id === '';

      return true;
    }

    this.value.recurrence_diff_jobs = true; // Set it back to the default value (Need this for the InstallationUnfinishedCombo)

    return false;
  }

  isDaySelected(day: { value: string; text: string }): boolean {
    if (!Array.isArray(this.value.days_of_week)) return false;
    return this.value.days_of_week.some((d: any) => d.value === day.value);
  }

  toggleDay(day: { value: string; text: string }) {
    if (!Array.isArray(this.value.days_of_week)) {
      this.$set(this.value, 'days_of_week', []);
    }
    const idx = this.value.days_of_week.findIndex((d: any) => d.value === day.value);
    if (idx >= 0) {
      this.value.days_of_week.splice(idx, 1);
    } else {
      this.value.days_of_week.push(day);
    }
    this.showDayError = this.value.days_of_week.length === 0;
    this.onDaysChange();
  }

  /** Two-char abbreviation so Tue/Thu and Mon/Mon don't collide across locales */
  dayLabel(day: { value: string; text: string }): string {
    return String(day.text).substring(0, 2);
  }

  @Watch('value.scheduled_start')
  onStartDateChange(newDate: string) {
    if (newDate) {
      setRecurrenceDayOnInput(this.value, this.userChangedDaysOfWeek);
      if (!this.editSeries) {
        this.value.end_date = dayjs(newDate).add(1, 'year').format('YYYY-MM-DD');
      }
    }
  }

  onTypeChange() {
    this.$nextTick(() => {
      recurrenceWeekToDays(this.value);
    });
  }

  onDaysChange() {
    this.userChangedDaysOfWeek = true;
  }

  onlyNumbers(event: any) {
    isNumber(event);
  }

  typeRules = [(v: any) => !!v || this.$t('recurrenceTypeRequired')];
  intervalRules = [(v: any) => !!v || this.$t('recurrenceIntervalRequired')];
  dayRules = [(v: any) => !!v || this.$t('recurrenceDaysRequired')];
}
